export const OrganizationsSummaryMockData = [
  {
    id: 'fc7c3553-d3ea-4538-9192-08db83c643a8',
    displayName: 'Mock Organization Item Display Name',
    email: 'mockorg@gmail.com',
    address: 'Mock Organization Item Address',
    createdOn: '2023-07-13T19:28:16.5707362+00:00',
    createdById: '3c59cbfb-c68b-eb11-b566-000d3a2238b1',
    isPartner: false,
    isBlocked: false,
  },
] as any[];
